import script from "./ProductsAndServices.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsAndServices.vue?vue&type=script&setup=true&lang=js"

import "./ProductsAndServices.vue?vue&type=style&index=0&id=701dfd6b&scoped=true&lang=css"

import exportComponent from "/home/appiah/Documents/projects/greenfield/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701dfd6b"]])

export default __exports__